import React from 'react';

import styled from 'styled-components';

export const Container = styled.div`
    font-size: 10px;
    line-height: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: auto;
    flex-direction: row;
    padding: 4px 0px;
    & > span {
        margin-left: 7px;
    }
    margin-bottom: 14px;
`;

export const Indicator = styled.div`
    height: ${({size}) => (size ? `${size}px` : '24px')};
    width: ${({size}) => (size ? `${size}px` : '24px')};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;
    color: #ffffff;
    font-family: 'AvenirNextRoundedStd';
    background-color: ${props => props.color && props.color};
    border-radius: 3px;
`;

const Classification = ({label, value, size, ...props}) => {
    const color = () => {
        switch (value) {
            case 'L':
                return '#00A651';

            default:
                return '#00A651';
        }
    };

    return (
        <Container>
            {label && <span>{label}</span>}
            <Indicator size={size} color={props.color || color()}>
                {value}
            </Indicator>
        </Container>
    );
};

export default Classification;
